import { getEmbedCode } from 'videojs-flash';
import ApiService from './api.service';

const FuneralHomeService = token => {
    const api = ApiService.createApiInstance(token);

    return {
        getSettingsAdmin(funeralHomeId) {
            return api.get(`/funeralhomes/settings/admin/${funeralHomeId}`);
        },
        getSettings(funeralHomeId) {
            return api.get(`/funeralhomes/settings/${funeralHomeId}`);
        },
        updateSettingsAdmin(data) {
            return api.put(`/funeralhomes/settings/admin`, data);
        },
        updateSettings(data) {
            return api.put(`/funeralhomes/settings`, data);
        },
        getBetaAccess(fhId) {
            return api.get(`/funeralhomes/settings/beta/${fhId}`);
        },
        deleteTributeEndingVideo(funeralHomeId) {
            return api.delete(`/funeralhomes/tribute-ending-video/${funeralHomeId}`, {
                useBugsnag: true,
            });
        },
        getTributeSettings(funeralHomeId) {
            return api.get(`/funeralhomes/settings/tribute/${funeralHomeId}`, {
                useBugsnag: true,
            });
        },
        updateTributeSettings(funeralHomeId, data) {
            return api.put(`/funeralhomes/settings/tribute/${funeralHomeId}`, data, {
                useBugsnag: true,
            });
        },
    };
};

export default FuneralHomeService;
